import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { MicrosoftTeamsTestComponent } from './test/test.component';

const routes: Routes = [
  {
    path: 'test',
    component: MicrosoftTeamsTestComponent
  },
  {
    path: 'tabs',
    loadChildren: () => import('./tabs/tabs.module').then(m => m.MicrosoftTeamsTabsModule)
  },
];

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  providers: [
    ],
  declarations: [
    MicrosoftTeamsTestComponent
    ]
})
export class MicrosoftTeamsModule {
  constructor() {
  }
}
